import { Box, Container, Grid } from '@mui/material';
import { ReactElement, useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { getProduct } from '@app/adapter/catalog-service';
import { ProductDetails } from '@app/components/Product/ProductDetails';
import { HeadBlock } from '@app/components/Shared/HeadBlock';
import { Loading } from '@app/components/Shared/Loading';
import { useSetSnackbar } from '@app/hooks/useSetSnackbar';
import { Product } from '@app/types/catalog';
import { isError } from '@app/utils/error';

export function ExhibitionPreview(): ReactElement {
  const { productId } = useParams();
  const setSnackbar = useSetSnackbar();
  const [product, setProduct] = useState<Product | null>(null);

  const fetchProduct = useCallback(async () => {
    if (!productId) return;
    try {
      const result = await getProduct(productId);
      setProduct(result.data);
    } catch (e) {
      if (isError(e)) {
        console.error('fetchProduct', e.message);
      }
      setSnackbar(true, '住宅展示場が見つかりません');
    }
  }, [productId, setSnackbar]);

  useEffect(() => {
    void fetchProduct();
    // eslint-disable-next-line
  }, []);

  if (!product) {
    return <Loading />;
  }

  return (
    <>
      <HeadBlock isNoIndex />
      <Box>
        <Container sx={{ mx: 'auto' }} maxWidth="xl" disableGutters>
          <Grid container spacing={3} justifyContent={'center'}>
            <Grid item xs={12} md={9} sx={{ width: '100%' }}>
              <ProductDetails product={product} isExhibition={true} />
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}
